<div class="master-main">
    <div class="main-wrapper">

        <div class="head-button">
            <button class="r-btn" (click)="backToMainScreen()"><i class="icon bi bi-arrow-left"></i></button>
            <span class="head-text">Master Item</span>
        </div>
        <div class="master-details-wrapper">

            <div class="details-left">
                <app-master-version-details></app-master-version-details>
                <app-file-attachments-container
                    entityType="master"
                    [entityId]="+allMastersService.masterItem().id">
                </app-file-attachments-container>
            </div>
            <div class="details-right">
                <app-master-details-component></app-master-details-component>
            </div>

        </div>
    </div>
</div>
